import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'
import type {
  FollowListTabNav,
  FollowMeProfile,
  FollowMeSharedBet,
} from '@core/Areas/FollowMe/types'
import { IncomingBetViewPostIdSearchParam } from '@core/Areas/FollowMe/Components/ProfileDisplay/constants'

export const navigateToProfileFollowingList = (
  profileId: FollowMeProfile['id'],
  isMyProfile = false
) => appHistory.push(getFollowListRoute({ profileId, listType: 'following', isMyProfile }))

export const navigateToProfileFollowersList = (
  profileId: FollowMeProfile['id'],
  isMyProfile = false
) => appHistory.push(getFollowListRoute({ profileId, listType: 'followers', isMyProfile }))

export const navigateToMyProfileWithViewBet = ({ postId }: Pick<FollowMeSharedBet, 'postId'>) =>
  appHistory.push(AppRoutes.BetLoopMyProfile + `?${IncomingBetViewPostIdSearchParam}=${postId}`)

// =============
// Local Helpers
// =============

function getFollowListRoute({
  listType,
  profileId,
  isMyProfile = false,
}: {
  listType: FollowListTabNav
  profileId: FollowMeProfile['id']
  isMyProfile: boolean
}): FollowListRoute {
  if (isMyProfile) {
    return `${AppRoutes.BetLoopMyProfileFollowList}?tab=${listType}`
  }
  return `${AppRoutes.BetLoopProfile}/${profileId}/follow-list?tab=${listType}`
}

// =====
// Types
// =====

type FollowListRoute =
  | `${typeof AppRoutes.BetLoopProfile}/${FollowMeProfile['id']}/follow-list?tab=${FollowListTabNav}`
  | `${typeof AppRoutes.BetLoopMyProfileFollowList}?tab=${FollowListTabNav}`
